import React from "react";
import { useDownloadExcel } from "../hooks/useDownloadExcel";
import { uiNotification } from "../../../../services/UINotificationService";
import styles from "./DownloadExcel.module.scss";

export const DownloadExcel = ({ selectedIds }) => {
  const { downloadExcel, isLoading } = useDownloadExcel();

  const handleDownload = () => {
    if (selectedIds.length === 0) {
      uiNotification.error(
        "Please select at least one purchase order to export.",
      );
      return;
    }
    downloadExcel(selectedIds);
  };

  return (
    <button
      className={styles.downloadButton}
      onClick={handleDownload}
      disabled={selectedIds.length === 0 || isLoading}
    >
      <i className="fa fa-download"></i>
      {isLoading ? "Downloading..." : "Download Excel"}
    </button>
  );
};
